  document.addEventListener("DOMContentLoaded", function () {
        const params = new URLSearchParams(window.location.search);
    const hasPageParam = params.has('page');
    const target = document.querySelector(".popular_blogs");
    if (hasPageParam && target) {
      // Wait a short time to allow content to load (especially with pagination or animations)
      setTimeout(function () {
        
        if (target) {
          target.scrollIntoView({ behavior: "smooth" });
        }
      }, 300); // adjust delay as needed
    }
  });
